<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <div class="border-wrapper">
                        <div class="border-wrapper__heading border-wrapper__heading--blue">
                            YOUR EVENTS
                        </div>

                        <b-input-group>
                            <b-form-input v-model="filter" placeholder="Type to search" class="tb-form-field tb-form-field--large" />
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''" class="tb-clear-button">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>

                        <b-table class="mt-3 tb-table"
                                 stacked="md"
                                 :filter="filter"
                                 :items="events"
                                 :fields="fields">

                            <template slot="actions" slot-scope="row">
                                <b-button class="btn-info mr-2 tb-table__button tb-table__button--blue" :to="{ name: 'event', params: { id: row.item.id } }">
                                    Manage
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    import clientRepository from "@/repository/clients";

    export default {
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        sortable: true
                    },
                    {   
                        key: "address_address",
                        label: "Address",
                        sortable: true
                    },
                    {
                        label: "Invites",
                        key: 'invites.length'
                    },
                    "actions"
                ],
                filter: "",
                client: null,
                events: [],
                loaded: false
            }
        },

        mounted() {
            let client_id = this.$store.getters.user.client.id;

            clientRepository.getById(client_id, {
                include: ['events', 'events.invites']
            }) 
            .then(response => {
                this.client = response.data;
                this.events = response.data.events;

                // calculate start_time and end_time via .days

                this.loaded = true;
            });
        }
    }
</script>

<style scoped>

</style>